import type { MapProp } from './world-types.js';

/** Approximate ground footprint radius (metres) of each prop as drawn at scale 1 (base scale included). Shared by scenery scattering and the placement audit. */
export const PROP_RADIUS: Record<MapProp['kind'], number> = {
  lighthouse: 5.6, house: 4.5, chapel: 8.25, well: 1.2, boat: 3, wreck: 7, jetty: 6, camp: 5.5, sign: .9, grave: 1.02, 'cave-mouth': 24, banner: .98, cart: 2.1, 'standing-stones': 14,
  fence: 0, 'lamp-post': .68, haystack: 2.2, crates: 1.6, 'net-rack': 2.52, watchtower: 3.57, windmill: 3.91, stall: 2.38, laundry: 2.04, 'whale-bones': 9, cairn: .7, stalagmites: 3,
  'torch-wall': .4, rowboat: 2.34, brazier: .77, obelisk: 1.95, scarecrow: .72, 'dead-tree': 1.04, bridge: 0, 'tide-pool': 3, bones: 1.5,
  shrine: 1.2, milestone: .38, beehives: 2.2, woodpile: 1.35, anchor: 1.2, 'lobster-pots': 1.26, buoy: .56, 'ruined-tower': 5,
  chest: 1, satchel: .6, 'potion-stall': 2.4,
};

/**
 * The uniform scale each kind's builder is drawn at, bringing geometry authored oversized down to real-world size beside
 * 1.7–1.8 m heroes (small pieces may sit up to 10% over for legibility, landmarks at the top of the real range). A prop's own
 * `scale` multiplies it. Collision authored beside a prop uses the same factor.
 */
export const PROP_BASE_SCALE: Partial<Record<MapProp['kind'], number>> = {
  lighthouse: .8, house: .75, chapel: .75, watchtower: .85, windmill: .85, well: .6, stall: .85, cart: .7, crates: .8, woodpile: .75, 'net-rack': .7, laundry: .6,
  sign: .75, milestone: .75, banner: .75, 'lamp-post': .85, 'torch-wall': .8, brazier: .55, shrine: .75, grave: .85, cairn: .5, obelisk: .75, scarecrow: .6,
  rowboat: .65, anchor: .6, 'lobster-pots': .7, buoy: .7, 'dead-tree': 1.3,
};

/** The scale a prop is drawn at: its kind's base scale times its own. */
export const propScale = (prop: Pick<MapProp, 'kind' | 'scale'>) => (PROP_BASE_SCALE[prop.kind] ?? 1) * (prop.scale ?? 1);
